module.exports = __webpack_public_path__ + "img/banner.10f5a6b0.jpg";